import PropTypes from 'prop-types';
import { Stack, Paper, Container, Typography, IconButton, Box, Divider, TextField, Modal } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Form, FormikProvider, useFormik } from 'formik';
import { useStyles } from '../styles/clientFormModalStyles';
import ClientSchema from '../schema';
import Iconify from '../../../components/iconify';
import { ADD_CLIENT_FORM_TITLE, EDIT_CLIENT_FORM_TITLE, INITIAL_FORM_STATE } from '../constants';

const ClientFormModal = ({ open, onClose, onSubmit, selectedRow, action }) => {
  const classes = useStyles();

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await onSubmit(values);
    setSubmitting(false);
  };

  let initialValues;
  if (action === 'create') {
    initialValues = INITIAL_FORM_STATE;
  } else if (action === 'update') {
    const clientName = selectedRow?.clientName;
    initialValues = { clientName };
  }

  const formik = useFormik({
    initialValues,
    validationSchema: ClientSchema,
    onSubmit: handleSubmit,
  });

  const { errors, touched, isSubmitting, submitForm, getFieldProps, resetForm } = formik;

  const handleClose = () => {
    onClose();
    resetForm({ values: INITIAL_FORM_STATE });
  };

  let headerText = '';
  if (action === 'create') {
    headerText = ADD_CLIENT_FORM_TITLE;
  } else if (action === 'update') {
    headerText = EDIT_CLIENT_FORM_TITLE;
  }

  return (
    <Modal className={classes.modal} open={open} onClose={handleClose}>
      <Box className={classes.root}>
        <Paper className={classes.paper}>
          <Box className={classes.modalHeader}>
            <Typography variant="h5" className={classes.headerText}>
              {headerText}
            </Typography>
            <IconButton color="primary" onClick={handleClose}>
              <Iconify icon="ic:round-clear" />
            </IconButton>
          </Box>
          <Divider className={classes?.divider} />
          <Container maxWidth="sm">
            <FormikProvider value={formik}>
              <Form onSubmit={formik?.handleSubmit}>
                <Stack spacing={2}>
                  <TextField
                    autoFocus
                    label="Client name"
                    {...getFieldProps('clientName')}
                    inputProps={{ maxLength: 60 }}
                    error={touched.clientName && Boolean(errors.clientName)}
                    helperText={touched.clientName && errors.clientName}
                    fullWidth
                  />
                  <LoadingButton fullWidth size="large" onClick={submitForm} variant="contained" loading={isSubmitting}>
                    Save
                  </LoadingButton>
                </Stack>
              </Form>
            </FormikProvider>
          </Container>
        </Paper>
      </Box>
    </Modal>
  );
};

ClientFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedRow: PropTypes.object,
  action: PropTypes.string.isRequired,
};

export default ClientFormModal;
